import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2PublicRecordAPIError,
  GetTkv2PublicRecordAPIVariables,
  fetchGetTkv2PublicRecordAPI,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';
import { Registry } from './registry.ts';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getTkv2PublicRecordAPI;

export function useGetTkv2PublicRecordAPI(
  variables: GetTkv2PublicRecordAPIVariables,
  opts?: UseQueryOptions<Response, GetTkv2PublicRecordAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetTkv2PublicRecordAPIError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/publicRecord',
      operationId: 'getTkv2PublicRecordAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetTkv2PublicRecordAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
